import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert} from "react-bootstrap";
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formataDataApi, formataDataExibicao, formataCNPJ, formataCPF, getCurrentUser, validaSenha} from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import { FaCheck, FaTimes, FaStream, FaEye, FaEyeSlash } from "react-icons/fa";

class OperadoresEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeCep = this.onChangeCep.bind(this);
        this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
        this.loadDefaultGroup = this.loadDefaultGroup.bind(this);

        this.enviaOperador = this.enviaOperador.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            tipo_pessoa: 'fisica',
            cpf: '',
            nome: "",
            email: "",
            celular: "",
            genero: "",
            cep: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
            carteira_id: '',
            carteira_nome: '',
            nomeHelper: "",
            cpfHelper: "",
            emailHelper: "",
            telefoneHelper: "",
            cepHelper: '',
            enderecoHelper: '',
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cidadeHelper: '',
            ufHelper: '',
            clienteIdHelper: '',
            erroLoadOperador: "",
            operador_id: "",
            titulo_pagina: "",
            loading: false,
            senha: '',
            senha_confirma: '',
            mostrarSenha: { senha: false, senhaConfirma: false },
            requisitosSenha: {
                tamanho: false,
                minuscula: false,
                maiuscula: false,
                numero: false,
                especial: false
            },
            grupo_id: '',
            grupo_nome: 'Atendentes (Navegadoras)',
        };

        this.list_sexos = {"F": "Feminino", "M": "Masculino", "O": "Outro"};

        this.list_tipos_pessoa = {"fisica": "Física", "juridica": "Jurídica"};

        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };

    }

    componentDidMount(){
        this.loadDefaultGroup();

        const id = this.props.router.params.id;

        if(id){
            this.setState({
                operador_id: id,
                titulo_pagina: 'Editando Navegador',
                loading: true,
                erroLoadOperador: ''
            })

            //consulta os dados do operador na api
            api.get(`/pessoas/operadores/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                //os campos opcionais vêm null da api; sem o fallback o state guarda null
                //e o FormData enviaria a string "null" no salvamento
                this.setState({
                    erroLoadOperador: '',
                    nome: dados.dados_pessoa.nome || '',
                    cpf: (dados.dados_pessoa.cpf_cnpj) ? formataCPF(dados.dados_pessoa.cpf_cnpj) : '',
                    email: dados.dados_pessoa.email || '',
                    celular: dados.dados_pessoa.celular || '',
                    genero: dados.dados_pessoa.genero || '',
                    cep: dados.dados_pessoa.cep || '',
                    endereco: dados.dados_pessoa.endereco || '',
                    numero: dados.dados_pessoa.numero || '',
                    complemento: dados.dados_pessoa.complemento || '',
                    bairro: dados.dados_pessoa.bairro || '',
                    cidade: dados.dados_pessoa.cidade || '',
                    uf: dados.dados_pessoa.uf || '',
                    carteira_id: dados.carteira_id || '',
                    carteira_nome: '',
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar navegador, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadOperador: erro_msg,
                })
            });
        }
        else {
            this.setState({
                operador_id: '',
                titulo_pagina: 'Adicionar Navegador',
                loading: false,
                erroLoadOperador: '',
            })
        }
    }

    carregarCarteiras = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/carteiras/?nome=${inputValue}`);
            const opcoes = response.data.results.map(carteira => ({
                value: carteira.id,
                label: carteira.nome
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar carteiras:', error);
            return [];
        }
    };

    async loadDefaultGroup() {
        try {
            const nomeGrupo = 'Atendentes (Navegadoras)';
            const response = await api.get(`/grupos/?name=${encodeURIComponent(nomeGrupo)}`);
            const match = response.data.results.find(g => g.name === nomeGrupo);
            if (match) {
                this.setState({ grupo_id: match.id });
            } else {
                console.warn('Grupo padrão não encontrado');
            }
        } catch (error) {
            console.error('Erro ao carregar grupo padrão:', error);
        }
    }

    enviaOperador = (e) => {
        e.preventDefault();

        if (this.state.senha) {
            if (!validaSenha(this.state.senha)) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Senha Fraca',
                    text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                    showCloseButton: true,
                });
                return;
            }
    
            if (this.state.senha !== this.state.senha_confirma) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'As senhas não coincidem.',
                    showCloseButton: true,
                });
                return; // Para interromper a execução se houver erro
            }
        }

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: '',
            cpfHelper: '',
            emailHelper: '',
            telefoneHelper: '',
        });

        //vererifica se é edição ou adição
        const url = (this.state.operador_id) ? '/pessoas/operadores/'+this.state.operador_id+'/' : '/pessoas/operadores/'
        const metodo = (this.state.operador_id) ? 'put' : 'post'

        //FormData converte null/undefined nas strings "null"/"undefined" — sempre normalizar
        const valor = (v) => (v === null || v === undefined) ? '' : v;

        formData.append('tipo_pessoa', valor(this.state.tipo_pessoa));
        formData.append('nome', valor(this.state.nome));
        formData.append('cpf_cnpj', valor(this.state.tipo_pessoa === 'fisica' ? this.state.cpf : this.state.cnpj));
        formData.append('email', valor(this.state.email));
        formData.append('celular', valor(this.state.celular));
        formData.append('cep', valor(this.state.cep));
        formData.append('endereco', valor(this.state.endereco));
        formData.append('numero', valor(this.state.numero));
        formData.append('complemento', valor(this.state.complemento));
        formData.append('bairro', valor(this.state.bairro));
        formData.append('cidade', valor(this.state.cidade));
        formData.append('uf', valor(this.state.uf));
        formData.append('carteira_id', valor(this.state.carteira_id));
        formData.append('senha', valor(this.state.senha));
        formData.append('grupo_id', valor(this.state.grupo_id));

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.operador_id) ? 'Navegador atualizado com sucesso' : 'Navegador cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.operador_id){
                this.props.router.navigate("/operadores");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar navegador, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'email'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'celular'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'cep'){
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'endereco'){
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'numero'){
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cidade'){
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'uf'){
                        this.setState({ ufHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    onChangeTipoPessoa = (e) => {
        this.setState({
            tipo_pessoa: e.target.value,
            cpf: '',
            cnpj: '',
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'carteira_id') {
            this.setState({ carteira_id: event.value, carteira_nome: event.label });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    //campos com máscara (IMaskInput) precisam de onAccept: no onChange o valor colado
    //é reformatado pela máscara sem avisar o React, e o state fica desatualizado
    handleMaskAccept = (field) => (value) => {
        this.setState({ [field]: value });
    };

    onChangeCep(cep) {
        this.setState({ cep: cep });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            endereco: res.data.logradouro,
                            complemento: res.data.complemento,
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                });
        }
    }

    carregarGrupos = async (inputValue) => {
        if(!this.state.focusGrupo) return [];

        try {
            const response = await api.get(`/grupos/?name=${inputValue}`);
            
            // Lista de nomes permitidos
            const nomesPermitidos = [
                'Atendentes (Navegadoras)'
            ];
            
            // Filtrar os grupos com base nos nomes permitidos
            const opcoes = response.data.results
                .filter(grupo => nomesPermitidos.includes(grupo.name))
                .map(grupo => ({
                    value: grupo.id,
                    label: grupo.name
                }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar grupos:', error);
            return [];
        }
    };

    // Função para alternar a visibilidade da senha
    toggleSenhaVisibilidade = campo => {
        this.setState(prevState => ({
            mostrarSenha: { ...prevState.mostrarSenha, [campo]: !prevState.mostrarSenha[campo] }
        }));
    }

    verificaRequisitosSenha = (senha) => {
        const requisitos = {
            tamanho: senha.length > 8,
            minuscula: /[a-z]/.test(senha),
            maiuscula: /[A-Z]/.test(senha),
            numero: /[0-9]/.test(senha),
            especial: /[$@#&!]/.test(senha)
        };
        this.setState({ requisitosSenha: requisitos });
    }

    onChangeGrupo = (grupoSelecionado) => {
        this.setState({ grupo_id: grupoSelecionado ? grupoSelecionado.value : '', grupo_nome: grupoSelecionado ? grupoSelecionado.label : '' });
    };

    render(){
        let dados_usuario = getCurrentUser();
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Form onSubmit={this.enviaOperador}>
                            <h4>Dados do Navegador</h4>
                            <Row>
                                {this.state.tipo_pessoa === 'fisica' ? (
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>CPF</Form.Label>
                                        <Form.Control as={IMaskInput} required mask="000.000.000-00" placeholder="CPF" name="cpf" id="formCpf" value={this.state.cpf} onAccept={this.handleMaskAccept('cpf')} />
                                        <Form.Text id="formCpfHelpBlock" className="text-danger">{this.state.cpfHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                ) : (
                                    <>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CNPJ</Form.Label>
                                                <Form.Control as={IMaskInput} required mask="00.000.000/0000-00" placeholder="CNPJ" name="cnpj" id="formCnpj" value={this.state.cnpj} onAccept={this.handleMaskAccept('cnpj')} />
                                                <Form.Text id="formCpfHelpBlock" className="text-danger">{this.state.cnpjHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>   
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Razão Social</Form.Label>
                                                <Form.Control type="text" required placeholder="Razão Social" name="razao_social" id="forRazaoSocial" value={this.state.razao_social} onChange={this.handleChange} />                            
                                                <Form.Text id="formRazaoSocialHelpBlock" className="text-danger">{this.razaoSocialHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome Fantasia</Form.Label>
                                                <Form.Control type="text" required placeholder="Nome Fantasia" name="nome_fantasia" id="formNomeFantasia" value={this.state.nome_fantasia} onChange={this.handleChange} />                            
                                                <Form.Text id="formNomeFantasiaHelpBlock" className="text-danger">{this.nomeFantasiaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </>
                                )}
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control type="text" required placeholder="Nome" name="nome" value={this.state.nome} onChange={this.handleChange} />                            
                                        <Form.Text id="formNomeHelpBlock" className="text-danger">{this.nomeHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" required placeholder="E-mail" name="email" id="formEmail" value={this.state.email} onChange={this.handleChange} />                            
                                        <Form.Text id="formEmailHelpBlock" className="text-danger">{this.state.emailHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Celular</Form.Label>
                                        <Form.Control as={IMaskInput} required mask="(00) 00000-0000" placeholder="Celular" name="celular" id="formTelefone" value={this.state.celular} onAccept={this.handleMaskAccept('celular')} />
                                        <Form.Text id="formTelefoneHelpBlock" className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <h4 className="mt-3">Endereço</h4>
                                <Col sm={12} xs={12}>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CEP</Form.Label>
                                                <Form.Control as={IMaskInput} mask="00000-000" name="cep" type="text" placeholder="CEP" value={this.state.cep} onAccept={this.onChangeCep} />
                                                <Form.Text id="formCEPHelpBlock" className="text-danger">{this.state.cepHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Endereço</Form.Label>
                                                <Form.Control type="text" placeholder="Endereço" name="endereco" value={this.state.endereco} onChange={this.handleChange} />
                                                <Form.Text id="formEnderecoHelpBlock" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Número</Form.Label>
                                                <Form.Control type="text" placeholder="Número" name="numero" value={this.state.numero} onChange={this.handleChange} />
                                                <Form.Text id="formNumeroHelpBlock" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Complemento</Form.Label>
                                                <Form.Control type="text" placeholder="Complemento" name="complemento" value={this.state.complemento} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Bairro</Form.Label>
                                                <Form.Control type="text" placeholder="Bairro" name="bairro" value={this.state.bairro} onChange={this.handleChange} />
                                                <Form.Text id="formBairroHelpBlock" className="text-danger">{this.state.bairroHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cidade</Form.Label>
                                                <Form.Control type="text" placeholder="Cidade" name="cidade" value={this.state.cidade} onChange={this.handleChange} />
                                                <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>UF</Form.Label>
                                                <Form.Control as="select" value={this.state.uf} name="uf" onChange={this.handleChange}>
                                                    <option value="">Selecione o Estado</option>
                                                    {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="formUFHelpBlock" className="text-danger">{this.state.ufHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>                                    
                                </Col>
                            </Row>  
                            {dados_usuario['is_superuser'] && (
                                <>
                                    <h4 className="mt-3">Dados de Acesso</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                            <Form.Label>Grupo de Usuário</Form.Label>
                                            <p>{this.state.grupo_nome}</p>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>                                        
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3 position-relative">
                                                <Form.Label>Senha <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type={this.state.mostrarSenha.senha ? "text" : "password"}
                                                    name="senha"
                                                    placeholder="Senha"
                                                    value={this.state.senha}
                                                    onChange={this.handleChange}
                                                />
                                                <i
                                                    onClick={() => this.toggleSenhaVisibilidade('senha')}
                                                    className="senha-icon"
                                                    style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                >
                                                    {this.state.mostrarSenha.senha ? <FaEyeSlash /> : <FaEye />}
                                                </i>
                                            </Form.Group>
                                            <p className="mb-0">Requisitos da senha: </p>
                                            <ul>
                                                <li style={{ color: this.state.requisitosSenha.tamanho ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.tamanho ? '700' : '400' }}>
                                                    Quantidade de caracteres maior que 8 {this.state.requisitosSenha.tamanho && <FaCheck />}
                                                </li>
                                                <li style={{ color: this.state.requisitosSenha.minuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.minuscula ? '700' : '400' }}>
                                                    Uma letra minuscula {this.state.requisitosSenha.minuscula && <FaCheck />}
                                                </li>
                                                <li style={{ color: this.state.requisitosSenha.maiuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.maiuscula ? '700' : '400' }}>
                                                    Uma letra maiuscula {this.state.requisitosSenha.maiuscula && <FaCheck />}
                                                </li>
                                                <li style={{ color: this.state.requisitosSenha.numero ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.numero ? '700' : '400' }}>
                                                    Um número de 0 a 9 {this.state.requisitosSenha.numero && <FaCheck />}
                                                </li>
                                                <li style={{ color: this.state.requisitosSenha.especial ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.especial ? '700' : '400' }}>
                                                    Pelo menos um dos seguintes caracteres $@#&! {this.state.requisitosSenha.especial && <FaCheck />}
                                                </li>
                                            </ul>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3 position-relative">
                                                <Form.Label>Confirmar Senha <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type={this.state.mostrarSenha.senhaConfirma ? "text" : "password"}
                                                    name="senha_confirma"
                                                    placeholder="Confirmar Senha"
                                                    value={this.state.senha_confirma}
                                                    onChange={this.handleChange}
                                                />
                                                <i
                                                    onClick={() => this.toggleSenhaVisibilidade('senhaConfirma')}
                                                    className="senha-icon"
                                                    style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                >
                                                    {this.state.mostrarSenha.senhaConfirma ? <FaEyeSlash /> : <FaEye />}
                                                </i>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {this.state.erroLoadOperador ? 
                            <Alert variant="warning">
                                {this.state.erroLoadOperador}
                            </Alert> : ''
                            }          
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> Salvar
                                    </>
                                )}
                            </Button>
                        </Form> 
                    </Card.Body>                
                </Card>
            </div>
        )
    }
}

export default withRouter(OperadoresEdit);